import { ScoopChip } from '../../../../ui'
import { severityColor, severityLabel } from '../../utils/severity'

/**
 * SeverityTag — the ONLY chip-form severity rendering in the DI tab
 * (target-state doctrine, review D2/D3): one component, fed by the canonical
 * severity module, so severity looks identical on every surface.
 *
 * Dense contexts (the run tree) use the dot+word form instead — see
 * RunBrowserTree — but never a third invention.
 */
export const SeverityTag = ({ severity, size = 'small', className }) => (
    <ScoopChip
        size={size}
        color={severityColor(severity)}
        label={severityLabel(severity)}
        className={className}
    />
)
